import { useMemo } from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { IntlShape } from "react-intl";

import floorToFixed from "@app/util/number/floorToFixed";
import isFloat from "@app/util/number/isFloat";

const useCoordinatesValidation = (intl: IntlShape, form: FormInstance) =>
  useMemo(
    () => [
      {
        validator: () => {
          const { latitude, longitude } = form.getFieldsValue();

          let error = false;
          const latitudeParsed =
            latitude && isFloat(latitude) ? floorToFixed(Number(latitude), 6) : NaN;
          const longitudeParsed =
            longitude && isFloat(longitude) ? floorToFixed(Number(longitude), 6) : NaN;
          if (
            latitude === undefined ||
            longitude === undefined ||
            latitude === null ||
            longitude === null
          ) {
            return Promise.resolve();
          } else if (isNaN(latitudeParsed) || isNaN(longitudeParsed)) {
            error = true;
          } else {
            const latitude = Math.abs(latitudeParsed);
            const longitude = Math.abs(longitudeParsed);
            if (latitude <= 90 && longitude <= 180) {
              return Promise.resolve();
            } else if (!latitude && !longitude) {
              return Promise.resolve();
            } else {
              error = true;
            }
          }

          if (error) {
            return Promise.reject(
              intl.formatMessage({
                id: "validation.coordinates.message",
                defaultMessage: "Please enter valid coordinates",
                description: "Validation message for coordinates fields - latitude and longitude",
              })
            );
          }

          return Promise.resolve();
        },
      },
    ],
    [intl, form]
  );

export const areCoordinatesValid = (
  latitude: string | undefined,
  longitude: string | undefined
) => {
  if (latitude && longitude && isFloat(latitude) && isFloat(longitude)) {
    return !(
      Number(latitude) <= 90 &&
      Number(latitude) >= -90 &&
      Number(longitude) >= -180 &&
      Number(longitude) <= 180
    );
  }
  return true;
};

export default useCoordinatesValidation;
